// extracted by mini-css-extract-plugin
export default {"emailAddress":"SignIn_emailAddress__gyHqR","primaryButton":"SignIn_primaryButton__gsPDd","secondaryButton":"SignIn_secondaryButton__tJWtR"};